// // // import React, { useEffect, useState } from "react";
// // // import "./App.css";

// // // import { useLocation } from "react-router-dom";

// // // import Header from "./components/header/Header";
// // // import Footer from "./components/footer/Footer";
// // // import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
// // // import AllRoutes from "./components/AllRoutes/AllRoutes";
// // // import New_Routes from "./components/New_Routes/New_Routes";
// // // import Welcomepage from "./components/Welcomepage/Welcomepage";

// // // function App() {
// // //   const location = useLocation();

// // //   const isWelcomePage = location.pathname === "/";

// // //   const isAuthPage =
// // //     location.pathname === "/login" ||
// // //     location.pathname === "/register" ||
// // //     location.pathname === "/forgetpassword";

// // //   const isNewPage = location.pathname.startsWith("/new");

// // //   const [showSplashScreen, setShowSplashScreen] = useState(false);

// // //   useEffect(() => {
// // //     if (isWelcomePage) {
// // //       setShowSplashScreen(true);

// // //       const timer = setTimeout(() => {
// // //         setShowSplashScreen(false);
// // //       }, 3000);

// // //       return () => clearTimeout(timer);
// // //     }

// // //     setShowSplashScreen(false);
// // //   }, [isWelcomePage]);

// // //   // ================= SPLASH SCREEN =================
// // //   if (isWelcomePage && showSplashScreen) {
// // //     return (
// // //       <div className="splash-screen">
// // //         <img
// // //           className="headlogo"
// // //           src="/assets/images/logo/logo.webp"
// // //           alt="Logo"
// // //         />
// // //       </div>
// // //     );
// // //   }

// // //   // ================= WELCOME PAGE =================
// // //   if (isWelcomePage) {
// // //     return <Welcomepage />;
// // //   }

// // //   // ================= OTHER PAGES =================
// // //   return (
// // //     <>
// // //       <ScrollToTop />

// // //       {!isAuthPage && <Header />}
// // //       {isNewPage ? <New_Routes /> : <AllRoutes />}
// // //       {!isAuthPage && <Footer />}
// // //     </>
// // //   );
// // // }

// // // export default App;

// // import React, { useEffect, useState } from "react";
// // import "./App.css";
// // import { useLocation } from "react-router-dom";
// // import Header from "./components/header/Header";
// // import Footer from "./components/footer/Footer";
// // import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
// // import AllRoutes from "./components/AllRoutes/AllRoutes";
// // import New_Routes from "./New_Folder/New_Routes/New_Routes";
// // import Welcomepage from "./components/Welcomepage/Welcomepage";
// // import NewHeader from "./New_Folder/Header/NewHeader";

// // function App() {
// //   const location = useLocation();
// //   const isWelcomePage = location.pathname === "/";
// //   const isAuthPage =
// //     location.pathname === "/login" ||
// //     location.pathname === "/register" ||
// //     location.pathname === "/forgetpassword";

// //   const isNewPage = location.pathname.startsWith("/new");
// //   const [showSplashScreen, setShowSplashScreen] = useState(false);
// //   useEffect(() => {
// //     if (isWelcomePage) {
// //       setShowSplashScreen(true);

// //       const timer = setTimeout(() => {
// //         setShowSplashScreen(false);
// //       }, 3000);

// //       return () => clearTimeout(timer);
// //     }

// //     setShowSplashScreen(false);
// //   }, [isWelcomePage]);

// //   // ================= SPLASH SCREEN =================
// //   if (isWelcomePage && showSplashScreen) {
// //     return (
// //       <div className="splash-screen">
// //         <img
// //           className="headlogo"
// //           src="/assets/images/logo/logo.webp"
// //           alt="Logo"
// //         />
// //       </div>
// //     );
// //   }

// //   // ================= WELCOME PAGE =================
// //   if (isWelcomePage) {
// //     return <Welcomepage />;
// //   }

// //   // ================= OTHER PAGES =================
// //   return (
// //     <>
// //       <ScrollToTop />

// //       {/* ================= HEADER ================= */}
// //       {!isAuthPage && (isNewPage ? <NewHeader /> : <Header />)}

// //       {/* ================= ROUTES ================= */}
// //       {isNewPage ? <New_Routes /> : <AllRoutes />}

// //       {/* ================= FOOTER ================= */}
// //       {!isAuthPage && (isNewPage ? <Footer /> : <Footer />)}
// //     </>
// //   );
// // }

// // export default App;

// import React, { useEffect, useState } from "react";
// import "./App.css";
// import "./New_Folder/Common_Components/common_css/Common_Form_Css.css";
// import { useLocation } from "react-router-dom";

// import Header from "./components/header/Header";
// import Footer from "./components/footer/Footer";
// import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
// import AllRoutes from "./components/AllRoutes/AllRoutes";
// import New_Routes from "./New_Folder/New_Routes/New_Routes";
// import Welcomepage from "./components/Welcomepage/Welcomepage";
// import NewHeader from "./New_Folder/Header/NewHeader";
// import New_Footer from "./New_Folder/New_Footer/New_Footer";

// function App() {
//   const location = useLocation();

//   const isWelcomePage = location.pathname === "/";

//   const isAuthPage =
//     location.pathname === "/login" ||
//     location.pathname === "/register" ||
//     location.pathname === "/forgetpassword";

//   const isNewPage = location.pathname.startsWith("/new");

//   const [showSplashScreen, setShowSplashScreen] = useState(false);

//   useEffect(() => {
//     if (isWelcomePage) {
//       setShowSplashScreen(true);

//       const timer = setTimeout(() => {
//         setShowSplashScreen(false);
//       }, 3000);

//       return () => clearTimeout(timer);
//     }

//     setShowSplashScreen(false);
//   }, [isWelcomePage]);
//   if (isWelcomePage && showSplashScreen) {
//     return (
//       <div className="splash-screen">
//         <img
//           className="headlogo"
//           src="/assets/images/logo/logo.webp"
//           alt="Logo"
//         />
//       </div>
//     );
//   }
//   if (isWelcomePage) {
//     return <Welcomepage />;
//   }

//   return (
//     <>
//       <ScrollToTop />

//       {!isAuthPage && <>{isNewPage ? <NewHeader /> : <Header />}</>}

//       {/* ROUTES */}
//       {isNewPage ? <New_Routes /> : <AllRoutes />}

//       {/* FOOTER */}
//       {!isAuthPage && <>{isNewPage ? <New_Footer /> : <Footer />}</>}
//     </>
//   );
// }

// export default App;

import React from "react";
import "./App.css";
import "./New_Folder/Common_Components/common_css/Common_Form_Css.css";
import { useLocation } from "react-router-dom";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import AllRoutes from "./components/AllRoutes/AllRoutes";
import New_Routes from "./New_Folder/New_Routes/New_Routes";
import Welcomepage from "./components/Welcomepage/Welcomepage";
import NewHeader from "./New_Folder/Header/NewHeader";
import New_Footer from "./New_Folder/New_Footer/New_Footer";
import WhatsappChatbot from "./New_Folder/Common_Components/chatbot/Chatbot";

function App() {
  const location = useLocation();

  const isWelcomePage = location.pathname === "/";

  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/forgetpassword";

  const isNewPage = location.pathname.startsWith("/new");

  // ================= WELCOME PAGE =================
  if (isWelcomePage) {
    return <Welcomepage />;
  }

  return (
    <>
      <ScrollToTop />
     {isNewPage && <WhatsappChatbot />}


      {/* HEADER */}
      {!isAuthPage && <>{isNewPage ? <NewHeader /> : <Header />}</>}

      {/* ROUTES */}
      {isNewPage ? <New_Routes /> : <AllRoutes />}

      {/* FOOTER */}
      {!isAuthPage && <>{isNewPage ? <New_Footer /> : <Footer />}</>}
    </>
  );
}

export default App;
